import React, { useEffect, useState } from 'react';
import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import apiClient from '../../../Services/ApiClient';
import { useAppContext } from '../../../Services/AppContext';
import { useHealthPlanContext } from '../../../Services/HealthPlanContext';
import { getCustomSchedule } from '../../Monitoring/Services/monitoring.service';
import { useIsLatam } from '../../Region/Services/region.service';
import HealthPlanMonitoringBabyLatam from '../Components/HealthPlanMonitoring/HealthPlanMonitoringBabyLatam';
import HealthPlanMonitoringDiabetesLatam from '../Components/HealthPlanMonitoring/HealthPlanMonitoringDiabetesLatam';
import {
	FormHookMonitoringCountry,
	FormHookResult,
} from './FormHook.interface';

const HealthPlanMonitoringForms: FormHookMonitoringCountry = {
	latam: {
		meddibaby: HealthPlanMonitoringBabyLatam,
		diabetes: HealthPlanMonitoringDiabetesLatam,
	},
	// TODO Add actual forms in case country is not latam
	default: {
		meddibaby: HealthPlanMonitoringBabyLatam,
		diabetes: HealthPlanMonitoringDiabetesLatam,
	},
};

const useHealthPlanMonitoringForm = (month: number = 0): FormHookResult => {
	const { healthPlan, healthPlanUser, activeHealthPlanUserItem } =
		useHealthPlanContext();
	const { globalTemplate } = useAppContext();

	const [form, setForm] = useState<ItemScheme[]>(
		HealthPlanMonitoringForms.default[
			healthPlan.code ?? HealthPlanCode.DIABETES
		],
	);
	const isLatam = useIsLatam(globalTemplate);
	// Everyone will hate me for this line, writing ternary statements is the definition of insanity
	const index = month - 1 < 0 ? 0 : month - 1 > form.length - 1 ? 0 : month - 1;

	useEffect(() => {
		const formScheme =
			HealthPlanMonitoringForms[isLatam ? 'latam' : 'default'][
				healthPlan.code ?? HealthPlanCode.DIABETES
			];
		if (healthPlan.code === HealthPlanCode.BABY) setForm(formScheme[index]);
		else setForm(formScheme);
	}, [healthPlan.code, isLatam, index]);

	const submitValues = async (
		values: Record<string, any>,
		onSuccess?: () => void,
	): Promise<void> => {
		const dataToSend = values;
		for (const key of Object.keys(dataToSend)) {
			const item = dataToSend[key];
			if (item?.customSending) {
				dataToSend[key].customSchedule = getCustomSchedule(item.customSending);
			}
		}

		await apiClient.patch(
			[
				'/health-plan',
				healthPlanUser?.healthPlanId,
				'user',
				healthPlanUser?.id,
				'item',
				activeHealthPlanUserItem?.id,
			].join('/'),
			{
				extra: {
					data: dataToSend,
				},
			},
		);
		console.log(values);
		onSuccess?.();
	};

	return {
		formScheme: form,
		submitValues,
	};
};

export default useHealthPlanMonitoringForm;
